import React, { } from 'react';
import "./style.css";

import Breadcrumb from 'react-bootstrap/Breadcrumb'

const NavBreadcrumb = (props) => {
    const{mainPage,innerPage,innerSubPage,mainRef,innerRef,homeRef,home}=props;
    return (
      <div className="conatainer">
          <div className="bread-crumb-custom">
            <Breadcrumb>
                <Breadcrumb.Item href={homeRef}><img src={home !== undefined ? home : null} alt={home !== undefined ? "home" : null}/>
                </Breadcrumb.Item>
                <span>{mainPage !== undefined ? <i className="fa fa-angle-right breadcrumb-angle" aria-hidden="true"></i> : null}</span>                
                <Breadcrumb.Item href={mainRef}>{mainPage}</Breadcrumb.Item>
                <span>{innerSubPage !== undefined ? <i className="fa fa-angle-right breadcrumb-angle" aria-hidden="true"></i> : null}</span>
                <Breadcrumb.Item active>{innerSubPage}</Breadcrumb.Item>
                {/* <span>{innerRef != undefined ? <i class="fa fa-angle-right breadcrumb-angle" aria-hidden="true"></i> : null}</span> */}
                <Breadcrumb.Item href={innerRef}>{innerPage}</Breadcrumb.Item>
                </Breadcrumb>
            </div>
      </div>
    );
  };
  
  export default NavBreadcrumb;